import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthProvider";

export default function ClientAdminDashboard() {
  const { user } = useAuth();

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-2">Client Admin Dashboard</h1>
      <p className="mb-6 text-gray-600">
        Welcome {user?.full_name}. Manage your company’s data and users.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Tenant-scoped user approvals (your existing page can be filtered server-side by company_id) */}
        <Link
          to="/admin/pending-users" // reuse if it already filters by company; else create a tenant version
          className="block p-4 border rounded-lg shadow hover:bg-gray-50"
        >
          <h2 className="font-semibold mb-1">Pending Users</h2>
          <p className="text-sm text-gray-600">Approve users in your company</p>
        </Link>

        {/* Procurement / Invoices links that are tenant-safe */}
        <Link to="/procurement" className="block p-4 border rounded-lg shadow hover:bg-gray-50">
          <h2 className="font-semibold mb-1">Procurement</h2>
          <p className="text-sm text-gray-600">POs, receiving, vendor bills</p>
        </Link>

        <Link to="/invoice/approval" className="block p-4 border rounded-lg shadow hover:bg-gray-50">
          <h2 className="font-semibold mb-1">Invoice Approvals</h2>
          <p className="text-sm text-gray-600">Review & approve invoices</p>
        </Link>

        <Link to="/vendor-directory" className="block p-4 border rounded-lg shadow hover:bg-gray-50">
          <h2 className="font-semibold mb-1">Vendors</h2>
          <p className="text-sm text-gray-600">Manage your supplier directory</p>
        </Link>
      </div>
    </div>
  );
}
